import React, { useEffect } from "react"
import { i18n } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { useDispatch } from "react-redux"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import { orderStatusPageDataUrl, footerUrl, headerUrl } from "@/constants"
import AemGrid from "@/components/AemGrid"
import {
  getAemServerAxiosInstance,
  getAemServerModelJsonAxiosInstance,
} from "@/services/server/aem.server"
import { getClienIP, getDataLayerObj, filterBackEndJson } from "@/utils/helper"
import {
  setDatalayerPageName,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"
import OrderStatus from "@/components/Shared/OrderStatus/v1/OrderStatus"
import OrderStatusFiller from "@/components/Shared/OrderStatus/v1/OrderStatusFiller"
const OrderStatusPage = ({
  locale,
  tmpData: data,
  headertmp: header,
  footertmp: footer,
  ip,
  globalScript,
  footerScript,
  analysticsScript,
  analyticsData,
  datalayerPageName,
  gbhDataLayerCustom,
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])
  useEffect(() => {
    dispatch(setDatalayerPageName(datalayerPageName))
    dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => {
      dispatch(setDatalayerPageName(""))
      dispatch(setGbhDataLayerCustom(""))
    }
  }, [])
  return (
    <>
      <GlobalPageHeader
        themeType={data?.appliedCssClassNames}
        header={header}
        title={data.title}
        globalScripting={globalScript}
        analysticsScript={analysticsScript}
        data={data}
      />
      <AemGrid
        data={data}
        count={0}
        orderStatus={data => <OrderStatus data={data} />}
        orderStatusFiller={() => <OrderStatusFiller />}
      />
      <GlobalPageFooter footer={footer} footerScripting={footerScript} />
    </>
  )
}

/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */
export async function getServerSideProps({ req, locale }) {
  await i18n?.reloadResources()
  const serverAemApi = getAemServerAxiosInstance()
  const serverAemModelJsonApi = getAemServerModelJsonAxiosInstance()
  const ip = getClienIP(req)
  const urlPath = req.url.split("?")[0]
  const { data } = await serverAemModelJsonApi({
    url: orderStatusPageDataUrl,
    method: "GET",
  })
  const { data: header } = await serverAemApi({
    url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
    method: "GET",
  })
  const { data: footer } = await serverAemApi({
    url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
    method: "GET",
  })
  const globalScript = data?.globalScript || null
  const footerScript = data?.footerScript || null
  const topHeadScript = data?.topHeadScript ? data?.topHeadScript : null
  const analyticsScriptClass = data?.analyticsScriptClass
    ? data?.analyticsScriptClass
    : null
  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
  }
  const analysticsScript = data?.adobeAnalytic || null
  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  const analyticsData = data?.data
  const datalayerPageName = data?.datalayerPageName
  tmpData = filterBackEndJson(tmpData)
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  const metaContent = data?.metaContent ?? ""
  return {
    props: {
      ip,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      topHeadScript,
      analysticsScript,
      analyticsScriptClass,
      analyticsData,
      datalayerPageName,
      gbhDataLayerCustom,
      urlPath,
      metaContent,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}
export default OrderStatusPage
